import { Tag } from '@cian/components';
import * as React from 'react';

import { EHouseLineType } from '../../../../json_query';
import { IHouseLineShoppingAreaTag } from '../../../state/tags/definitions/house_line.shopping_area';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHouseLineShoppingAreaTagProps {
  tag: IHouseLineShoppingAreaTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const houseLineShoppingAreaMap = {
  [EHouseLineType.First]: 'Первая линия домов (торг.площадь)',
  [EHouseLineType.Second]: 'Вторая линия домов (торг.площадь)',
};

export const HouseLineShoppingAreaTag = (props: IHouseLineShoppingAreaTagProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {houseLineShoppingAreaMap[props.tag.value]}
    </TagComponent>
  );
};
